import { render, staticRenderFns } from "./EditReasonAction.vue?vue&type=template&id=16c0408b&scoped=true&"
import script from "./EditReasonAction.vue?vue&type=script&lang=js&"
export * from "./EditReasonAction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16c0408b",
  null
  
)

export default component.exports